import { Col, DatePicker, Form, Input, Row, Select, Typography } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import CommentDelivery from './CommentDelivery';
import ProductDelivery from './ProductDelivery';
import TableDeliExport from './TableDeliExport';
import CountryPhoneInput from '@root/core/components/CountryPhoneInput';
import { useParams } from 'react-router-dom';
import deliveryService from '@root/modules/Warehouse/Delivery/services/delivery';
import moment from 'moment';
import metaApi from '../../../../core/components/CountryPhoneInput/meta-service';
import { DownOutlined } from '@ant-design/icons';
import {
  CommentGroup,
  CommentList,
  CommentTabs,
  CommentType,
  CreateComment
} from '@core/components/CommentTabs/interface';
import commentService from '@core/components/CommentTabs/commentService';
import CommentTabsComponent from '@core/components/CommentTabs';

const { Option } = Select;
const { Title, Paragraph, Text, Link } = Typography;

interface ICountry {
  calling_code: string;
  flag: string;
  id: number;
  language: string;
  lookupCode: string;
  lookupCodeId: string;
  priority: string;
  value: string;
}

interface Props {
  listPro: any;
  _getDetailDe: () => void;
  listDetail: any;
}

const WrapInfoDeli = ({ listPro, _getDetailDe, listDetail }: Props) => {
  const { idDelivery }: any = useParams();
  const { Text } = Typography;
  const [countryCodes, setCountryCodes] = useState<ICountry[]>([] as any);
  const [tabs, setTabs] = useState<CommentTabs[]>([]);

  /*-------------------country code------------------------------*/

  const _getCountry = async () => {
    const responseData = await metaApi['getMetaData']();

    const reOrderData = [...responseData?.data.country_code];
    const slie = listDetail?.recipientCountryCode?.replace('+', '');
    const fill = reOrderData.filter(
      (item: any) => item.lookupCodeId === slie
    );
    setCountryCodes(fill);
  };

  const [commentList, setCommentList] = useState<CommentList>();

  const onSendComment = async (body: CreateComment, id?: number) => {
    if (id) {
      await commentService.updateComment(id, body);
    } else {
      await commentService.sendComment(body);
    }
    await getCommentList();
  };

  const getCommentList = async (showLoading?: Boolean) => {
    if (showLoading) {
    }
    const comments = await commentService.getComments({
      group: CommentGroup.DELIVERY_DETAIL,
      itemId: Number(idDelivery)
    });
    setCommentList(comments);
    if (showLoading) {
    }
  };

  useEffect(() => {
    getCommentList();
  }, []);

  useEffect(() => {
    _getCountry();
  }, [listDetail?.recipientCountryCode]);

  /*----------*/
  const [form] = Form.useForm();

  useEffect(() => {
    const mapProductComment: any = listDetail;

    form.setFieldsValue({
      orderNumber: mapProductComment.orderNumber,
      buyerName: mapProductComment.buyerName,
      recipientName: mapProductComment.recipientName,
      orderDate: moment(mapProductComment.orderDate)
        .utc()
        .format('YYYY-MM-DD hh:mm:ss'),
      buyerEmail: mapProductComment.buyerEmail,
      shippingAddress: mapProductComment.shippingAddress,
      saleChannel: mapProductComment.saleChannel,
      recipientPhone: mapProductComment.recipientPhone,
      street: mapProductComment.shippingAddress,
      postalCode: mapProductComment.postalCode,
      country: mapProductComment.country,
      detailAddress: mapProductComment.detailAddress,
      detailAddress2: mapProductComment.detailAddress2,
      city: mapProductComment.city,
      state: mapProductComment.state,
    });

    if (mapProductComment.status === 'Request') {
      setTabs([
        {
          title: 'Comment',
          type: CommentType.COMMON,
          description: 'Comment from Warehouse :'
        },
        {
          title: 'Request modify',
          description: 'Reasons for modification from Warehouse :',
          type: CommentType.REQUEST_MODIFY,
          options: []
        }
      ]);
    } else {
      setTabs([]);
    }
  }, [listDetail]);

  useEffect(() => {
    //@ts-ignore
    if (commentList?.data?.length > 0) {
      //@ts-ignore
      const lastComment = commentList.data[commentList.data.length - 1];
      if (lastComment.side === 'WAREHOUSE' && lastComment.type === 'COMMON') {
        setTabs([
          {
            title: 'Comment',
            type: CommentType.COMMON,
            description: 'Comment from Warehouse :'
          }
        ]);
      }
    }
  }, [commentList]);

  return (
    <div>
      <div className="infoDeli">
        {/* {listDelivery.map((item: any) => ( */}
        <div
        // key={item.key}
        >
          {' '}
          <Form form={form} layout="vertical">
            <Row className="rowDeliver" gutter={1}>
              <Col span={7}>
                <Form.Item label="Order Number" name="orderNumber">
                  <Input className="border-input" disabled />
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item label="Buyer Name" name="buyerName">
                  <Input className="border-input" disabled />
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item label="Recipient Name" name="recipientName">
                  <Input className="border-input" disabled />
                </Form.Item>
              </Col>
            </Row>
            <Row className="rowDeliver" gutter={1}>
              <Col span={7}>
                <Form.Item label="Buyer Name" name="buyerName">
                  <Input className="border-input" disabled />
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item label="Buyer Email" name="buyerEmail">
                  <Input className="border-input" disabled />
                </Form.Item>
              </Col>
              <Col span={7}>
              </Col>
            </Row>
            <Row className="rowDeliver" gutter={1}>
              <Col span={7}>
                <Form.Item label="Recipient Name" name="recipientName">
                  <Input className="border-input" disabled />
                </Form.Item>
              </Col>
              <Col span={14} style={{display: 'flex'}}>
                <Form.Item label="Shipping Country/Address" name="country">
                  <Input className="border-input" disabled style={{flex: '0 1 140px'}}/>
                </Form.Item>
                <Form.Item name="shippingAddress" style={{flex: '1 0 auto', marginTop: '37px', marginLeft: '10px'}}>
                  <Input className="border-input" disabled />
                </Form.Item>
              </Col>
            </Row>
            <Row className="rowDeliver" gutter={1}>
              <Col span={7} className="rowPhoneNumber">
                <Form.Item label="Recipient Phone Number">
                  <Input.Group
                    style={{ display: 'flex', flexDirection: 'row' }}
                  >
                    <Text keyboard className="textCountry" disabled>
                      {countryCodes.map((item: any) => (
                        <div
                          key={item.countryCode}
                          style={{ display: 'flex', alignItems: 'center' }}
                        >
                          {' '}
                          <img src={item.flag} alt="" width={24} height={24} />+
                          {item.calling_code}
                          <DownOutlined />
                        </div>
                      ))}
                    </Text>

                    <Form.Item name="recipientPhone" style={{ width: '100%' }}>
                      <Input className="border-input" disabled />
                    </Form.Item>
                  </Input.Group>
                </Form.Item>
              </Col>
              <Col span={14} style={{display: 'flex', width: '100%'}}>
                <Row gutter={1} style={{width: '100%'}}>
                  <Col style={{width: '50%'}}>
                    <Form.Item name="detailAddress2">
                      <Input className="border-input" disabled/>
                    </Form.Item>
                  </Col>
                  <Col style={{width: '50%'}}>
                    <Form.Item name="detailAddress">
                      <Input className="border-input" disabled style={{marginLeft: '5px'}}/>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="rowDeliver" gutter={1}>
              <Col span={7}>
              </Col>
              <Col span={14} style={{display: 'flex'}}>
                <Row gutter={1} style={{width: '100%'}}>
                  <Col style={{width: '33.333%'}}>
                    <Form.Item name="city">
                      <Input className="border-input" disabled style={{marginTop: '-20px'}}/>
                    </Form.Item>
                  </Col>
                  <Col style={{width: '33.333%'}}>
                    <Form.Item name="state">
                      <Input className="border-input" disabled style={{marginTop: '-20px', marginLeft: '2px'}}/>
                    </Form.Item>
                  </Col>
                  <Col style={{width: '33.333%'}}>
                    <Form.Item name="postalCode">
                      <Input className="border-input" disabled style={{marginTop: '-20px', marginLeft: '5px'}}/>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
        {/* ))} */}
      </div>{' '}
      <ProductDelivery listPro={listPro} />
      <CommentDelivery listDetail={listDetail} />
      <CommentTabsComponent
        style={{ borderTop: 0, paddingTop: 0 }}
        onSend={onSendComment}
        tabs={tabs}
        commentList={commentList!}
        refectComments={getCommentList}
        itemId={Number(idDelivery)}
        commentGroup={CommentGroup.DELIVERY_DETAIL}
      />
      <TableDeliExport
        listDetail={listDetail}
        // listPro={listPro}
        _getDetailDe={_getDetailDe}
      />
    </div>
  );
};

export default WrapInfoDeli;
